<template>
    <div class="container">
        <div class="box">
            <h3 class="title reveal-bottom">{{ $t("vn.t") }}</h3>
            <p class="text reveal-bottom">
                {{ $t("vn.c") }}
            </p>
            <p class="text-p reveal-bottom">
                {{ $t("vn.cc") }}
            </p>
            <div class="img1 reveal-bottom">
                <img
                    style="width:1200px;"
                    :src="
                        lang === 'en_US'
                            ? require('@/assets/img_svg/retail_img_1_en.png')
                            : require('@/assets/img_svg/retail_img_1_cn.png')
                    "
                    alt="svg"
                />
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            lang: localStorage.getItem("lang"),
        };
    },
    mounted() {
        this.$bus.$on("lang", (lang) => (this.lang = lang));
    },
};
</script>
<style scoped>
.container {
    overflow: hidden;
    background-color: #fff;
}
.box {
    width: 1200px;
    margin: auto;
    padding: 0 10px;
    box-sizing: border-box;
}
.title {
    font-size: 44px;
    color: #000000;
    letter-spacing: 0;
    line-height: 66px;
    margin-top: 150px;
}
.text {
    font-size: 22px;
    color: rgba(0, 0, 0, 0.8);
    line-height: 44px;
    margin-top: 41px;
}
.text-p {
    font-size: 22px;
    color: rgba(0, 0, 0, 0.8);
    line-height: 44px;
}
.img {
    width: 1180px;
    height: 944px;
    margin-bottom: 187px;
}
.img1 {
    width: 1180px;
    height: 944px;
    margin-top: 95px;
    margin-bottom: 187px;
}
</style>



// WEBPACK FOOTER //
// src/Pages/Retail/Content0.vue